import React, { Component } from 'react'
import moment from "moment"
import { session } from "services/session"
import ApiHelper from "services/api-helper"
import { Button, Form, Select, TextArea, Modal } from "semantic-ui-react"
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import toastr from 'toastr'

export default class XacNhanKhaiBaoViecLam extends Component {
  state = {
    xacnhanList: [
      { value: 1, text: 'Chấp nhận' },
      { value: 0, text: 'Không chấp nhận' }
    ],
    obj: {
      XacNhanTruongNhom: 1,
      NoiDungXacNhan: ''
    }
  }
  save = () => {
    if (this.state.obj.NoiDungXacNhan === "") {
      alert("Nhập nội dung xác nhận");
      return;
    }
   
    const obj = {
      Oid: this.props.data.Oid,
      XacNhanTruongNhom: this.state.obj.XacNhanTruongNhom,
      NguoiXacNhan: session.WebUserId,
      NoiDungXacNhan: this.state.obj.NoiDungXacNhan
    }
    ApiHelper.PostJson('api/xacNhanKhaiBaoViecLam', obj).then(res => {
      toastr.success('Thành công!')
      this.props.closeModal()
    }, error => {
      toastr.error(error)
    })
  }
  handleChangeDate = (_ref) => {
    var startDate = _ref.startDate || this.state.obj.TuNgay
    var endDate = _ref.endDate || this.state.obj.DenNgay

    if (startDate.isAfter(endDate)) {
      _ref.startDate && (endDate = startDate)
      _ref.endDate && (startDate = endDate)
    }

    this.setState({ obj: { ...this.state.obj, TuNgay: startDate, DenNgay: endDate } })
  }
  handleChangeDateStart = (startDate) => {
    return this.handleChangeDate({ startDate })
  }
  handleChangeDateEnd = (endDate) => {
    return this.handleChangeDate({ endDate })
  }
  handleXacNhan = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, XacNhanTruongNhom: value } })
  }
  handleNoiDung = (e, { value }) => {
    this.setState({ obj: { ...this.state.obj, NoiDungXacNhan: value } })
  }
  
  render() {
    return (
      <Modal
        open={this.props.openModal}
        onClose={this.props.closeModal}>

        <Modal.Header>XÁC NHẬN VIỆC LÀM</Modal.Header>
        <Modal.Content>
          <Form>
            <Form.Group widths='equal'>
             
              {/* <Form.Field>
                <label>Đến ngày</label>
                <DatePicker
                  selected={this.state.obj.DenNgay}
                  selectsEnd
                  startDate={this.state.obj.TuNgay}
                  endDate={this.state.obj.DenNgay}
                  onChange={this.handleChangeDateEnd}
                  dateFormat="DD/MM/YYYY"
                  placeholderText="Đến ngày"
                />
              </Form.Field> */}
              <Form.Field control={Select} label='Xác nhận' options={this.state.xacnhanList}
                value={this.state.obj.XacNhanTruongNhom}
                onChange={this.handleXacNhan}
              />
            </Form.Group>
            <Form.Field>
              <label>Nội dung xác nhận (*)</label>
              <TextArea className="textarea-kblv" placeholder='Nội dung xác nhận'
                value={this.state.obj.NoiDungXacNhan}
                onChange={this.handleNoiDung}
              />
            </Form.Field>
         
          </Form>
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={this.props.closeModal} negative>
            Hủy
          </Button>
          <Button
            onClick={this.save}
            positive
            labelPosition='right'
            icon='checkmark'
            content='Lưu'
          />
        </Modal.Actions>
      </Modal>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/quan-ly-viec-lam-o-nha/xac-nhan-modal.jsx